<template>
  <div />
</template>
<script setup lang="ts">
const {$config} = useNuxtApp();

useHead({
  script: [{
    src: `https://www.google.com/recaptcha/api.js?render=${$config.public.recaptchaSiteKey}`, body: true, async: true,
  }],
});

defineExpose({
  validate,
  reset,
});

/**
 * Validate recaptcha
 */
async function validate () {
  if (window && (window as any).grecaptcha) {
    return new Promise(async(resolve) => {
      (window as any).grecaptcha.ready(async () => {
        const response = await (window as any).grecaptcha.execute($config.public.recaptchaSiteKey, {action: 'submit'});
        resolve(response);
      });
    });
  }
}

/**
 * Reset recaptcha
 */
async function reset () {
  if (window && (window as any).grecaptcha) {
    (window as any).grecaptcha.reset();
  }
}
</script>
